import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const bigCommerce = defineConnector({
  identifier: "bigCommerce",
  name: "BigCommerce",
  tagLine: "E-commerce platform",
  logo,
  protocol: "http",
  tags: ["productivity", "data"],
  defaultUrlPattern: () => "https://api\\.bigcommerce\\.com/.*",
  auth: (app) =>
    headerAuth([
      { name: "X-Auth-Token", value: app.secret.accessToken },
      { name: "Accept", value: "application/json" },
    ]),
  steps: [
    {
      title: "Create a BigCommerce API account",
      items: [
        {
          kind: "markdown",
          content:
            "In BigCommerce, create an API account and copy the store hash and access token. BigCommerce’s management APIs use the token in the `X-Auth-Token` header.",
        },
      ],
    },
    {
      title: "Enter your BigCommerce details",
      items: [
        {
          kind: "input",
          label: "Store hash",
          required: true,
          placeholder: "abc123",
          target: { kind: "configuration", field: "storeHash" },
        },
        {
          kind: "input",
          label: "Access token",
          required: true,
          target: { kind: "secrets", field: "accessToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ storeHash }) =>
      `https://api.bigcommerce.com/stores/${storeHash}/v2/store`,
  },
});
